import { useQuery, keepPreviousData } from '@tanstack/react-query';
import axios from 'axios';

const usePublicStore = (slug, { pos, check_in, check_out } = {}) => {
  return useQuery({
    queryKey: ['public-store', slug, pos ? 'pos' : 'storefront', check_in, check_out],
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const params = {};
      if (pos) params.pos = 1;
      if (check_in) params.check_in = check_in;
      if (check_out) params.check_out = check_out;

      const response = await axios.get(`/api/store/public/${slug}`, { params });
      return response.data;
    },
  });
};

export default usePublicStore;
